// src/data/Doctors.js

import about_dr_1 from "../assets/images/Doctor.jpg";
import DEBARAJU from "../assets/images/Doctors/DR-E-DEBARAJU-REDDY.jpg";
import RAMKRISHNA from "../assets/images/Doctors/RAMKRISHNA.jpg";
import SYAMBABU from "../assets/images/Doctors/DR-SYAM-BABU-KATURI.jpg";
import BINDU from "../assets/images/Doctors/DR-BINDU-BHARGAVI-CH.jpg";
import CHETAN from "../assets/images/Doctors/DR-CHETAN-NARRA.jpg";
import RAMESH from "../assets/images/Doctors/DR-RAMESH-CHANDRA-VADAPALLI.jpg";
import ANUSHA from "../assets/images/Doctors/DR-ANUSHA-KANTHETI.jpg";
import SUNEEL from "../assets/images/Doctors/DR-SUNEEL-KUMAR-KOMMINENI.jpg";
import PURVA from "../assets/images/Doctors/DR-PURVA-ARTHAM.jpg";
import AMULYA from "../assets/images/Doctors/DR-AMULYA.jpg";
import SINDHUJA from "../assets/images/Doctors/DR-Y-L-SINDHUJA.jpg";
import AVINASH from "../assets/images/Doctors/Dr.Avinash.jpg";
import MOUNIKA from "../assets/images/Doctors/Dr.Mounika.jpg";
import SAMANVITHA from "../assets/images/Doctors/Dr.Samanvitha.jpg";
import MOHIUDDIN from "../assets/images/Doctors/Dr.Mouiz.jpg";
import SHAMILI from "../assets/images/Doctors/Dr.Shamili.jpg";
import KALYAN from "../assets/images/Doctors/Dr.Kalyan.jpg";
import PAVAN from "../assets/images/Doctors/Dr.Pavan_Kumar_Ediga.jpg";
// import VAMSHI from "../assets/images/Doctor.jpg";
// import MANISHANKAR from "../assets/images/Doctor.jpg";
export const doctors = [
  {
    id: 1,
    name: "DR. E DEBARAJU REDDY",
    slug: "dr-e-debaraju-reddy",
    dignity:
      "CONSULTANT GENERAL & LAPAROSCOPIC SURGEON AND CHIEF MEDICAL SUPERITENDENT",
    degree: "MBBS, AFIH, DNB, FMAS, Dip. MAS, FALS, MBA, GMHE (IIM-B)",
    image: DEBARAJU,
    about: [
      "<strong>DR E DEBARAJU REDDY</strong> is a highly experienced General & Laparoscopic Surgeon and serves as the Chief Medical Superintendent. He specializes in minimally invasive surgeries and advanced surgical care. He is known for his leadership and patient-focused treatment approach.",
    ],

    specialization: "General & Laparoscopic Surgery",
    currentRole: "Chief Medical Superintendent",
    experience: "25",
    education: [
      "MBBS",
      "AFIH",
      "DNB (General Surgery)",
      "FMAS",
      "FALS",
      "Dip. MAS",
      "MBA in Hospital Management",
      "GMHE (IIM-B)",
    ],

    details: [
      "Gender: Male",
      "Languages: Telugu, English, Hindi",
      "Consultation: 9:00 AM – 5:00 PM",
      "Prachin Global Hospitals",
    ],
  },
  {
    id: 2,
    name: "DR. RAMKRISHNA PURAMWAR",
    slug: "dr-ramkrishna-puramwar",
    dignity: "CONSULTANT GENERAL MEDICINE & RHEUMATOLOGIST",
    degree: "MBBS, MD (GENERAL MEDICINE), FELLOWSHIP IN RHEUMATOLOGY",
    image: RAMKRISHNA,

    about: [
      "<strong>DR RAMKRISHNA PURAMWAR</strong> is a Consultant General Medicine & Rheumatology Specialist. He focuses on diagnosing and treating chronic medical conditions and joint-related disorders. He is dedicated to providing comprehensive internal medicine care.",
    ],

    specialization: "General Medicine & Rheumatology",

    currentRole: "Consultant Physician & Rheumatologist",
    experience: "9",
    education: ["MBBS", "MD (General Medicine)", "Fellowship in Rheumatology"],

    details: [
      "Gender: Male",
      "Languages: Telugu, English, Hindi",
      "Consultation: 10:00 AM – 4:00 PM",
      "Prachin Global Hospitals",
    ],
  },
  {
    id: 3,
    name: "DR. SYAM BABU KATURI",
    slug: "dr-syam-babu-katuri",
    dignity: "CONSULTANT GENERAL, LAPAROSCOPIC & LASER SURGEON",
    degree:
      "MBBS, MS (GENERAL SURGERY), FELLOW IN MINIMAL ACCESS SURGERY (FMAS)",
    image: SYAMBABU,

    about: [
      "<strong>DR SYAM BABU KATURI</strong> is a Consultant General, Laparoscopic & Laser Surgeon. He specializes in advanced laparoscopic procedures and minimally invasive surgeries. His expertise helps patients recover faster with less discomfort.",
    ],

    specialization: "General, Laparoscopic & Laser Surgery",

    currentRole: "Consultant General & Laparoscopic Surgeon",
    experience: "6",
    education: [
      "MBBS",
      "MS (General Surgery)",
      "Fellow in Minimal Access Surgery (FMAS)",
    ],

    details: [
      "Gender: Male",
      "Languages: Telugu, English, Hindi",
      "Consultation: 9:00 AM – 5:00 PM",
      "Prachin Global Hospitals",
    ],
  },
  {
    id: 4,
    name: "DR. BINDU BHARGAVI CH",
    slug: "dr-bindu-bhargavi-ch",
    dignity: "CONSULTANT OBSTETRICIAN & GYNEACOLOGIST AND LAPAROSCOPIC SURGEON",
    degree: "MBBS, DGO, DNB, FMAS, DMAS, FRM",
    image: BINDU,

    about: [
      "<strong>DR BINDU BHARGAVI CH</strong> is a Consultant Obstetrician & Gynaecologist and Laparoscopic Surgeon. She provides expert care in women’s health, pregnancy and gynaecological treatments. She is skilled in modern laparoscopic procedures for women.",
    ],

    specialization: "Obstetrics, Gynaecology & Laparoscopic Surgery",

    currentRole: "Consultant Obstetrician & Gynaecologist",
    experience: "7",
    education: ["MBBS", "DGO", "DNB", "FMAS", "DMAS", "FRM"],

    details: [
      "Gender: Female",
      "Languages: Telugu, English, Hindi",
      "Consultation: 9:00 AM – 5:00 PM",
      "Prachin Global Hospitals",
    ],
  },
  {
    id: 5,
    name: "DR. CHETAN NARRA",
    slug: "dr-chetan-narra",
    dignity:
      "CONSULTANT ORTHOPEDICS & JOINT REPLACEMENT AND PEDIATRICS ORTHOPEDIC SURGEON",
    degree: "MBBS, MS (ORTHO), FELLOW IN JOINT REPLACEMENT (FIJR)",
    image: CHETAN,

    about: [
      "<strong>DR CHETAN NARRA</strong> is a Consultant Orthopedic & Joint Replacement Surgeon specializing in pediatric orthopedics. He treats bone, joint and mobility disorders with advanced orthopedic techniques. He is committed to restoring movement and improving quality of life.",
    ],

    specialization: "Orthopedics, Joint Replacement & Pediatric Orthopedics",

    currentRole: "Consultant Orthopedic & Joint Replacement Surgeon",
    experience: "8",
    education: [
      "MBBS",
      "MS (Orthopedics)",
      "Fellow in Joint Replacement (FIJR)",
    ],

    details: [
      "Gender: Male",
      "Languages: Telugu, English, Hindi",
      "Consultation: 9:00 AM – 5:00 PM",
      "Prachin Global Hospitals",
    ],
  },
  {
    id: 6,
    name: "DR. RAMESH CHANDRA VADAPALLI",
    slug: "dr-ramesh-chandra-vadapalli",
    dignity:
      "SENIOR CONSULTANT JOINT REPLACEMENT, ARTHROSCOPY & SPORTS MEDICINE SURGEON",
    degree:
      "MS (ORTHO-MANIPAL), FIJR, FISM (ARTHOSCOPY, JOINT REPLACEMENTS & PEDIATRIC ORTHO) & SPORTS MEDICINE",
    image: RAMESH,

    about: [
      "<strong>DR RAMESH CHANDRA VADAPALLI</strong> is a Senior Consultant in Joint Replacement, Arthroscopy & Sports Medicine. He specializes in orthopedic surgeries, sports injuries and joint replacement treatments. His expertise helps patients regain strength and mobility effectively.",
    ],

    specialization: "Joint Replacement, Arthroscopy & Sports Medicine",

    currentRole: "Senior Consultant Orthopedic & Sports Medicine Surgeon",
    experience: "25",
    education: [
      "MS (Ortho - Manipal)",
      "FIJR",
      "FISM",
      "Arthroscopy",
      "Joint Replacements",
      "Pediatric Orthopedics",
      "Sports Medicine",
    ],

    details: [
      "Gender: Male",
      "Languages: Telugu, English, Hindi",
      "Consultation: 9:00 AM – 5:00 PM",
      "Prachin Global Hospitals",
    ],
  },
  // {
  //   id: 7,
  //   name: "MR ANIL BOORLA",
  //   dignity: "CONSULTANT GASTROENTEROLOGIST & HEPATOLOGIST",
  //   degree: "MBBS, MD (GENERAL MEDICINE), DM (GASTROENTEROLOGY)",
  //   image: about_dr_1,
  // },
  {
    id: 8,
    name: "DR. ANUSHA KANTHETI",
    slug: "dr-anusha-kantheti",
    dignity: "CONSULTANT PULMONOLOGIST & SOMNOLOGIST",
    degree:
      "MBBS (GOLD MEDAL), DNB RESPIRATORY MEDICINE, CERTIFIED SLEEP MEDICINE SPECIALIST, FID (UK)",
    image: ANUSHA,

    about: [
      "<strong>DR ANUSHA KANTHETI</strong> is a Consultant Pulmonologist & Somnologist. She specializes in respiratory diseases, lung care and sleep-related disorders. She focuses on improving breathing health and sleep quality for patients.",
    ],

    specialization: "Pulmonology, Respiratory Medicine & Sleep Disorders",

    currentRole: "Consultant Pulmonologist & Somnologist",
    experience: "7",
    education: [
      "MBBS (Gold Medal)",
      "DNB Respiratory Medicine",
      "Certified Sleep Medicine Specialist",
      "FID (UK)",
    ],

    details: [
      "Gender: Female",
      "Languages: Telugu, English, Hindi",
      "Consultation: 9:00 AM – 5:00 PM",
      "Prachin Global Hospitals",
    ],
  },
  // {
  //   id: 9,
  //   name: "DR ADEEBA ALI",
  //   dignity: "CONSULTANT RADIOLOGY",
  //   degree: "MBBS, MD (RADIOLOGY)",
  //   image: about_dr_1,
  // },
  {
    id: 10,
    name: "DR. SUNEEL KUMAR KOMMINENI",
    slug: "dr-suneel-kumar-kommineni",
    dignity: "CONSULTANT PEDIATRICIAN & NEONATOLOGIST",
    degree: "MBBS, MD (PEDIATRICS), FELLOWSHIP IN NEONATOLOGY",
    image: SUNEEL,

    about: [
      "<strong>DR SUNEEL KUMAR KOMMINENI</strong> is a Consultant Pediatrician & Neonatologist. He specializes in child healthcare and newborn intensive care. He is dedicated to ensuring healthy growth and development in infants and children.",
    ],

    specialization: "Pediatrics & Neonatology",

    currentRole: "Consultant Pediatrician & Neonatologist",
    experience: "6",
    education: ["MBBS", "MD (Pediatrics)", "Fellowship in Neonatology"],

    details: [
      "Gender: Male",
      "Languages: Telugu, English, Hindi",
      "Consultation: 9:00 AM – 5:00 PM",
      "Prachin Global Hospitals",
    ],
  },
  {
    id: 11,
    name: "DR. PURVA ARTHAM",
    slug: "dr-purva-artham",
    dignity: "CONSULTANT ENT, HEAD & NECK, SKULL BASE SURGEON",
    degree: "MBBS, MS (ENT), SKULL BASE SURGERY (MALAYSIA)",
    image: PURVA,

    about: [
      "<strong>DR PURVA ARTHAM</strong> is a Consultant ENT, Head & Neck Skull Base Surgeon. She specializes in ear, nose, throat and complex skull base surgeries. Her expertise includes advanced surgical treatment for head and neck disorders.",
    ],

    specialization: "ENT, Head & Neck & Skull Base Surgery",

    currentRole: "Consultant ENT & Skull Base Surgeon",
    experience: "6",
    education: ["MBBS", "MS (ENT)", "Skull Base Surgery (Malaysia)"],

    details: [
      "Gender: Female",
      "Languages: Telugu, English, Hindi",
      "Consultation: 9:00 AM – 5:00 PM",
      "Prachin Global Hospitals",
    ],
  },
  {
    id: 12,
    name: "DR. AVINASH BASWARAJU",
    slug: "dr-avinash-baswaraju",
    dignity: "CONSULTANT MAXILLO FACIAL & FACE RECONSTRUCTIVE SURGEON",
    degree: "MDS, MPH (AUS), FELLOWSHIP IN FACE RECONSTRUCTIVE SURGERY",
    image: AVINASH,

    about: [
      "<strong>DR AVINASH BASWARAJU</strong> is a Consultant Maxillofacial & Face Reconstructive Surgeon. He specializes in facial trauma, jaw surgery and reconstructive procedures. He is committed to restoring facial function and appearance with precision.",
    ],

    specialization: "Maxillofacial & Face Reconstructive Surgery",

    currentRole: "Consultant Maxillofacial & Reconstructive Surgeon",
    experience: "7",
    education: [
      "MDS",
      "MPH (AUS)",
      "Fellowship in Face Reconstructive Surgery",
    ],

    details: [
      "Gender: Male",
      "Languages: Telugu, English, Hindi",
      "Consultation: 09:00 AM – 5:00 PM",
      "Prachin Global Hospitals",
    ],
  },
  {
    id: 13,
    name: "DR. SAMANVITHA S",
    slug: "dr-samanvitha-s",
    dignity: "CONSULTANT DENTAL SURGEON",
    degree: "BDS, MDS",
    image: SAMANVITHA,

    about: [
      "<strong>DR SAMANVITHA S</strong> is a Consultant Dental Surgeon. She provides expert dental care including oral health treatments and preventive dentistry. She focuses on maintaining healthy and confident smiles.",
    ],

    specialization: "Dental Surgery & Preventive Dentistry",
    currentRole: "Consultant Dental Surgeon",
    experience: "7",
    education: ["BDS", "MDS"],

    details: [
      "Gender: Female",
      "Languages: Telugu, English, Hindi",
      "Consultation: 09:00 AM – 5:00 PM",
      "Prachin Global Hospitals",
    ],
  },
  // {
  //   id: 14,
  //   name: "DR MADHUSUDHAN KOGILA",
  //   dignity: "CONSULTANT PHYSIOTHERAPIST",
  //   degree: "MASTERS IN SPORTS AND MUSCULOSKELETAL REHABILITATION",
  //   image: about_dr_1,
  // },
  {
    id: 15,
    name: "DR. AMULYA",
    slug: "dr-amulya",
    dignity: "CONSULTANT CLINICAL NUTRITIONIST",
    degree: "BACHELORS IN CLINICAL NUTRITION & DIETETICS",
    image: AMULYA,

    about: [
      "<strong>DR AMULYA</strong> is a Consultant Clinical Nutritionist specializing in Clinical Nutrition & Dietetics. She guides patients with personalized nutrition plans for better health and wellness. Her focus is on preventive healthcare through proper diet management.",
    ],

    specialization: "Clinical Nutrition & Dietetics",

    currentRole: "Consultant Clinical Nutritionist",
    experience: "3",
    education: ["Bachelors in Clinical Nutrition & Dietetics"],

    details: [
      "Gender: Female",
      "Languages: Telugu, English, Hindi",
      "Consultation: 9:00 AM – 5:00 PM",
      "Prachin Global Hospitals",
    ],
  },
  {
    id: 16,
    name: "DR. Y L SINDHUJA",
    slug: "dr-y-l-sindhuja",
    dignity: "CONSULTANT PATHOLOGIST",
    degree: "MBBS, MD (PATHOLOGY), DipRCPath (UK)",
    image: SINDHUJA,

    about: [
      "<strong>DR Y L SINDHUJA</strong> is a Consultant Pathologist with expertise in disease diagnosis through laboratory investigations. She plays an important role in accurate medical testing and reports. Her work supports precise treatment decisions.",
    ],

    specialization: "Pathology & Laboratory Diagnostics",

    currentRole: "Consultant Pathologist",
    experience: "8",
    education: ["MBBS", "MD (Pathology)", "DipRCPath (UK)"],

    details: [
      "Gender: Female",
      "Languages: Telugu, English, Hindi",
      "Consultation: 9:00 AM – 5:00 PM",
      "Prachin Global Hospitals",
    ],
  },
  {
    id: 17,
    name: "DR. MANDALAPU MOUNIKA",
    slug: "dr-mandalapu-mounika",
    dignity:
      "CONSULTANT EMERGENCY MEDICINE, BLS & ACLS INSTRUCTOR, ATLS PROVIDER",
    degree: "MBBS, MEM, MRCEM",
    image: MOUNIKA,

    about: [
      "<strong>DR MANDALAPU MOUNIKA</strong> is a Consultant in Emergency Medicine and BLS & ACLS Training. She specializes in handling medical emergencies and critical care situations. She is also trained in emergency life-support instruction.",
    ],

    specialization: "Emergency Medicine & Critical Care",

    currentRole: "Consultant Emergency Medicine Specialist",
    experience: "6",
    education: ["MBBS", "MEM", "MRCEM"],

    details: [
      "Gender: Female",
      "Languages: Telugu, English, Hindi",
      "Consultation: 24/7 Emergency Care",
      "Prachin Global Hospitals",
    ],
  },
  {
    id: 18,
    name: "DR. SD MOIZ MOHIUDDIN KHAN",
    slug: "dr-sd-moiz-mohiuddin-khan",
    dignity: "CONSULTANT ANESTHESIOLOGIST & CRITICAL CARE INTENSIVIST",
    degree: "MBBS, MD (ANASTHESIA), BLS, ACLS PROVIDER (AHA), BCBR",
    image: MOHIUDDIN,

    about: [
      "<strong>DR SD MOIZ MOHIUDDIN KHAN</strong> is a Consultant Anesthesiologist & Critical Care Intensivist. He specializes in anesthesia management and intensive care treatment. He ensures patient safety during surgeries and critical medical care.",
    ],

    specialization: "Anesthesiology & Critical Care",
    experience: "5",
    currentRole: "Consultant Anesthesiologist & Critical Care Intensivist",

    education: [
      "MBBS",
      "MD (Anasthesia)",
      "BLS",
      "ACLS Provider (AHA)",
      "BCBR",
    ],

    details: [
      "Gender: Male",
      "Languages: Telugu, English, Hindi",
      "Consultation: 24/7 Critical Care Support",
      "Prachin Global Hospitals",
    ],
  },
  // {
  //   id: 19,
  //   name: "DR. MANISHANKAR Y",
  //   slug: "dr-manishankar-y",
  //   dignity: "HOD – CONSULTANT EMERGENCY MEDICINE",
  //   degree: "MBBS, MEM, FCCM",
  //   image: MANISHANKAR,

  // //   about: [
  // //     "<strong>DR MANISHANKAR Y</strong> is the Head of the Emergency Medicine Department. He specializes in emergency and critical care management. He leads the emergency team in providing rapid and effective lifesaving treatment.",
  // //   ],

  // //   specialization: "Emergency Medicine & Critical Care",

  // //   currentRole: "HOD – Consultant Emergency Medicine",
  // //   experience: "15",
  // //   education: ["MBBS", "MEM", "FCCM"],

  // //   details: [
  // //     "Gender: Male",
  // //     "Languages: Telugu, English, Hindi",
  // //     "Consultation: 24/7 Emergency Care",
  // //     "Prachin Global Hospitals",
  // //   ],
  // // },
  // },
  {
    id: 20,
    name: "DR GADDAM SHAMILI",
    slug: "dr-gaddam-shamili",
    dignity: "CONSULTANT OBSTETRICIAN & GYNECOLOGIST",
    degree: "MS (OBG), MRCOG - INFERTILITY",
    image: SHAMILI,

    about: [
      "<strong>DR GADDAM SHAMILI</strong> is a Consultant Obstetrician & Gynaecologist specializing in women’s healthcare and pregnancy management. She provides expert care in gynecology, infertility and maternal wellness. She is committed to ensuring safe and compassionate treatment for women of all ages.",
    ],

    specialization: "Obstetrics, Gynaecology & Infertility",

    currentRole: "Consultant Obstetrician & Gynaecologist",
    experience: "5",
    education: ["MS (OBG)", "MRCOG - Infertility"],

    details: [
      "Gender: Female",
      "Languages: Telugu, English, Hindi",
      "Consultation: 9:00 AM – 5:00 PM",
      "Prachin Global Hospitals",
    ],
  },
  // {
  //   id: 21,
  //   name: "DR. VAMSHI KRISHNA S",
  //   dignity: "CONSULTANT GENERAL SURGEON",
  //   degree: "MBBS, MS (GENERAL SURGERY)",
  //   image: VAMSHI,

  //   about: [
  //     "<strong>DR VAMSHI KRISHNA S</strong> is a Consultant General Surgeon with expertise in advanced surgical procedures. He specializes in diagnosing and treating a wide range of surgical conditions. His focus is on providing safe and effective patient care.",
  //   ],

  //   specialization: "General Surgery",

  //   currentRole: "Consultant General Surgeon",
  //   experience: "5",
  //   education: ["MBBS", "MS (General Surgery)"],

  //   details: [
  //     "Gender: Male",
  //     "Languages: Telugu, English, Hindi",
  //     "Consultation: 9:00 AM – 5:00 PM",
  //     "Prachin Global Hospitals",
  //   ],
  // },
  {
    id: 22,
    name: "DR. E PAVAN KUMAR",
    slug: "dr-e-pavan-kumar",
    dignity: "CONSULTANT NEUROSURGEON",
    degree: "MBBS, MS, MCh (NEURO SURGERY)",
    image: PAVAN,
    about: [
      "<strong>DR E PAVAN KUMAR</strong> is a Consultant Neurosurgeon specializing in brain, spine and nervous system surgeries. He is experienced in treating neurological disorders with advanced surgical techniques. His goal is to improve patients’ neurological health and quality of life.",
    ],

    specialization: "Neurosurgery & Spine Surgery",
    currentRole: "Consultant Neurosurgeon",
    experience: "4",
    education: ["MBBS", "MS", "MCh (Neuro Surgery)"],

    details: [
      "Gender: Male",
      "Languages: Telugu, English, Hindi",
      "Consultation: 9:00 AM – 5:00 PM",
      "Prachin Global Hospitals",
    ],
  },
  {
    id: 23,
    name: "DR. KALYAN VANGARA",
    slug: "dr-kalyan-vangara",
    dignity: "CONSULTANT SURGICAL ONCOLOGIST",
    degree:
      "MBBS, MS, MCh (SURGICAL ONCOLOGY), FMAS, FIAGES (Robotics & Laparoscopic Surgery)",
    image: KALYAN,

    about: [
      "<strong>DR KALYAN VANGARA</strong> is a Consultant Surgical Oncologist specializing in cancer surgeries and robotic laparoscopic procedures. He provides advanced treatment for various types of cancers using modern surgical methods. He is dedicated to precision care and better recovery outcomes.",
    ],

    specialization: "Surgical Oncology & Robotic Laparoscopic Surgery",

    currentRole: "Consultant Surgical Oncologist",
    experience: "11",
    education: [
      "MBBS",
      "MS",
      "MCh (Surgical Oncology)",
      "FMAS",
      "FIAGES (Robotics & Laparoscopic Surgery)",
    ],

    details: [
      "Gender: Male",
      "Languages: Telugu, English, Hindi",
      "Consultation: 9:00 AM – 5:00 PM",
      "Prachin Global Hospitals",
    ],
  },
  {
    id: 24,
    name: "DR. RANGANATH",
    slug: "dr-ranganath",
    dignity: "CONSULTANT NEPHROLOGIST",
    degree: "MBBS, MD, DM (NEPHROLOGY)",
    image: about_dr_1,

    about: [
      "<strong>DR RANGANATH</strong> is a Consultant Nephrologist specializing in kidney-related diseases and disorders. He focuses on the diagnosis and management of chronic kidney conditions and renal care. His expertise helps patients maintain better kidney health and overall wellness.",
    ],

    specialization: "Nephrology & Renal Care",

    currentRole: "Consultant Nephrologist",
    experience: "18",
    education: ["MBBS", "MD", "DM (Nephrology)"],

    details: [
      "Gender: Male",
      "Languages: Telugu, English, Hindi",
      "Consultation: 9:00 AM – 5:00 PM",
      "Prachin Global Hospitals",
    ],
  },
  {
    id: 26,
    name: "DR. SURESH BABU VALLEPU",
    slug: "dr-suresh-babu-vallepu",
    dignity: "CONSULTANT NEURO PHYSICIAN",
    degree: "MBBS, MD (GENERAL MEDICINE), DM (NEUROLOGY)",
    image: about_dr_1,

    about: [
      "<strong>DR SURESH BABU VALLEPU</strong> is a Consultant Neuro Physician specializing in the diagnosis and treatment of neurological disorders. He provides expert care for conditions such as stroke, epilepsy, migraines and nerve-related problems.",
    ],

    specialization: "Neurology & Neuro Medicine",

    currentRole: "Consultant Neuro Physician",
    experience: "4",
    education: ["MBBS", "MD (General Medicine)", "DM (Neurology)"],

    details: [
      "Gender: Male",
      "Languages: Telugu, English, Hindi",
      "Consultation: 9:00 AM – 5:00 PM",
      "Prachin Global Hospitals",
    ],
  },
];
